export default __webpack_public_path__ + "static/media/Boots of the Milites Templi.065c4137.jpg";